import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import ContactText from "../components/ContactText";

export default function SSOError() {
    return (
        <>
            <Box>
                <Typography variant="h1" gutterBottom color="error.main">
                    Oh no!
                </Typography>

                <Typography variant="h5" gutterBottom>
                    Something went wrong while signing you in.
                </Typography>

                <Typography gutterBottom>
                    Please try again later or get in touch so we can help you and figure out what happened.
                </Typography>

                <Typography gutterBottom>
                    <ContactText />
                </Typography>
            </Box>
        </>
    );
}
